import React from 'react';

/** Billing yoqilmagan yoki API key noto'g'ri bo'lganda */
export default function GoogleMapsLoadError({ error }) {
  return (
    <div className="h-full bg-amber-50 dark:bg-amber-950/30 rounded-[40px] flex flex-col items-center justify-center p-8 text-center">
      <span className="material-symbols-outlined text-[64px] text-amber-500 mb-4">warning</span>
      <h3 className="text-xl font-bold text-amber-800 dark:text-amber-200">Xarita yuklanmadi</h3>
      <p className="text-sm text-amber-700 dark:text-amber-300 mt-2 max-w-md">
        Odatda Google Cloud da <strong>billing</strong> yoqilmagan yoki API key cheklovi noto&apos;g&apos;ri.
        &quot;For development purposes only&quot; shu sabab chiqadi.
      </p>
      {error?.message && (
        <p className="text-xs text-amber-600 mt-3 font-mono bg-amber-100/50 dark:bg-amber-900/30 px-3 py-2 rounded-lg">
          {error.message}
        </p>
      )}
    </div>
  );
}
